<template>
  <div class="page-class page-user-list">
    <h1 class="page-title">{{ title }}</h1>
    <div v-if="socketDownload.active" class="download-progress-modal">
      <div class="progress-content">
        <h3>{{ socketDownload.status }}</h3>
        <div v-if="socketDownload.showProgress" class="progress-bar-container">
          <div class="progress-bar" :style="{ width: socketDownload.percent + '%' }">
            {{ socketDownload.percent }}%
          </div>
        </div>
        <p v-if="socketDownload.showProgress"> Chunks: {{ socketDownload.current }} / {{ socketDownload.total }} </p>
      </div>
    </div>

    <B2B-report-box
      :columns="columns"
      :rows="reportList"
      :baseUrl="baseUrl"
      :loading="loading"
      :showDownload="true"
      :showToolbar="true"
      :showDetialReportDownload="true"
      downloadDetailReportText="Download Detail Report"
      downloadText="Download Report"
      emptyText="No Data found."
      @download="onExportCSV"
      @detail-report="onDownloadDetailReport"
    >
    </B2B-report-box>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import _ from 'lodash';
import io from 'socket.io-client'; // ADD THIS: Import socket.io-client
import B2BReportBox from '../../components/B2BReportBox.vue';

export default {
  name: 'B2BReport',
  components: {
    B2BReportBox
  },
  metaInfo() {
    return {
      title: 'B2B Report',
      meta: [
        {
          name: 'description',
          content: `Manage Report`
        }
      ]
    };
  },
  mounted() {
    if (!this.storeListDetail.length) {
      this.listStoreDetail({ router: this.$router });
    }
    if (_.isEmpty(this.$route.query)) {
      this.list({
        query: {
          ...this.$route.query,
          startdate: moment().format('YYYY-MM-DD'),
          enddate: moment().format('YYYY-MM-DD')
        }
      });
    } else {
      this.list({
        query: this.$route.query
      });
    }
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.list({
      query: to.query
    });
    next();
  },
  data() {
    return {
      title: 'B2B BDA Wise ReportList',
      columns: [
        {
          type: 'row_num',
          headerText: '#',
          class: {
            'text-center': true
          },
          textKey: 'index',
          width: '4%'
        },
        {
          type: 'string',
          headerText: 'BDA Name',
          // class: {
          //   'text-center': true
          // },
          textKey: 'bdaName',
          width: '9%'
        },
        {
          type: 'string',
          headerText: 'Store Id',
          // class: {
          //   'text-center': true
          // },
          textKey: 'storeId',
          width: '4%'
        },
        {
          type: 'number',
          headerText: 'Total Order Created',
          class: {
            'text-center': true
          },
          textKey: 'totalOrderCreated',
          width: '8%'
        },
        {
          type: 'number',
          headerText: 'Total Item Count',
          class: {
            'text-center': true
          },
          textKey: 'totalItemCount',
          width: '9%'
        },
        {
          type: 'number',
          headerText: 'Sum Of Quantity Ordered',
          class: {
            'text-center': true
          },
          textKey: 'sumOfQuantity',
          width: '13%'
        },
        {
          type: 'number',
          headerText: 'Sum Of CartValue',
          textKey: 'sumOfCartValue',
          width: '10%'
        },
        {
          type: 'number',
          headerText: 'Total Challan Generated',
          class: {
            'text-center': true
          },
          textKey: 'totalChallanGenerated',
          width: '9%'
        },
        {
          type: 'number',
          headerText: 'Total Item Billed',
          class: {
            'text-center': true
          },
          textKey: 'totalItemBilled',
          width: '10%'
        },
        {
          type: 'number',
          headerText: 'Sum Of Quantity Billed',
          textKey: 'sumOfQuantityBilled',
          width: '12%'
        },
        {
          type: 'number',
          headerText: 'Sum Of Challan Value',
          textKey: 'sumOfChallanValue',
          width: '12%'
        }
      ],
      socket: null,
      csvChunks: [],
      socketDownload: {
        active: false,
        status: '',
        percent: 0,
        current: 0,
        total: 0,
        showProgress: false
      }
      // searchItems: ['Bill Number', 'Store Id']
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('B2BReport', ['downloadReport', 'loading', 'baseUrl', 'reportList']),
    ...mapState('store', ['storeListDetail'])
  },
  watch: {
    downloadReport(newValue) {
      if (newValue.length) {
        let csv =
          'BDA Name,Store Id,TotalOrderCreated,TotalItemCount,SumOfQuantity Ordered,SumOfCartValue,TotalChallanGenerated,TotalItemBilled, SumOfQuantityBilled,SumOfChallanValue \n';
        newValue.forEach(row => {
          csv += `${row.bdaName},${row.storeId},${row.totalOrderCreated},${row.totalItemCount},${row.sumOfQuantity},${row.sumOfCartValue},${row.totalChallanGenerated},${row.totalItemBilled},${row.sumOfQuantityBilled},${row.sumOfChallanValue}\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'B2B BDA Wise ReportList.csv';
        anchor.click();
      }
    }
  },
  methods: {
    ...mapActions('B2BReport', ['list', 'download', 'postOne']),
    ...mapActions('store', ['listStoreDetail', 'deleteOne']),
    async onDownloadDetailReport() {
      this.socketDownload = {
        active: true,
        status: 'Connecting...',
        percent: 0,
        current: 0,
        total: 0,
        showProgress: false
      };
      this.csvChunks = [];

      const token = localStorage.getItem('token'); // Your JWT token
      const storeId = 'S117';
      const mobileNumber = this.user?.mobile || '9999999999';
      const startDate = this.$route.query.startdate || moment().format('YYYY-MM-DD');
      const endDate = this.$route.query.enddate || moment().format('YYYY-MM-DD');

      try {
        let url = '';
        if (process.env.NODE_ENV === 'development') {
          url = 'http://localhost:8080';
        } else {
          url = 'https://spencer-apiv1.attabot.in';
        }
        this.socket = io(url, {
          auth: { token }
        });

        this.socket.on('connect', () => {
          this.socketDownload.status = 'Connected! Joining room...';
          this.socket.emit('join_room', { storeId, mobileNumber });
        });

        this.socket.on('connect_error', err => {
          console.error('Connection error:', err);
          this.socketDownload.status = 'Connection failed!';
          this.socketDownload.active = false;
        });

        this.socket.on('room_joined', () => {
          this.socketDownload.status = 'Requesting report...';
          this.triggerReportAPI(startDate, endDate, storeId, mobileNumber);
        });

        this.socket.on('csv-progress-init', data => {
          this.socketDownload.total = data.totalRows;
          this.socketDownload.showProgress = true;
          this.socketDownload.status = 'Generating CSV...';
        });

        this.socket.on('csv-chunk', data => {
          this.csvChunks.push(data.chunk);
          this.socketDownload.current += 1;
          this.socketDownload.percent = Math.round((this.socketDownload.current / this.socketDownload.total) * 100);
        });

        this.socket.on('csv-complete', _data => {
          this.socketDownload.status = 'Download complete! Saving file...';

          const blob = new Blob(this.csvChunks, { type: 'text/csv' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `b2b_detailed_report_${moment().format('YYYY-MM-DD')}.csv`;
          a.click();
          URL.revokeObjectURL(url);

          this.socket.emit('leave_room', { storeId, mobileNumber });
          this.socket.disconnect();
          this.socket = null;

          setTimeout(() => {
            this.socketDownload.active = false;
          }, 2000);
        });

        this.socket.on('csv-error', err => {
          console.error('CSV error:', err);
          this.socketDownload.active = false;
          if (this.socket) {
            this.socket.emit('leave_room', { storeId, mobileNumber });
            this.socket.disconnect();
            this.socket = null;
          }
        });
      } catch (error) {
        console.error('Error:', error);
        this.socketDownload.active = false;
      }
    },
    async triggerReportAPI(startDate, endDate, storeId, mobileNumber) {
      try {
        const params = {
          startdate: startDate,
          enddate: endDate,
          stores: [storeId],
          mobileNumber
        };

        await this.postOne({ params });
        this.socketDownload.status = 'Generating report';
      } catch (err) {
        console.error('API Error:', err);
      }
    },
    onExportCSV() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'startdate')) {
        this.download({
          query: {
            ...this.$route.query
          }
        });
      } else {
        this.download({
          query: {
            ...this.$route.query,
            startdate: moment().subtract(1, 'day').format('MMM YYYY')
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.download-progress-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.progress-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  min-width: 400px;
  text-align: center;
}

.progress-bar-container {
  width: 100%;
  height: 30px;
  background: #e9ecef;
  border-radius: 15px;
  overflow: hidden;
  margin: 20px 0;
}

.progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #007bff, #0056b3);
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
}
</style>
